import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const ascendConfig: TSPConfig = {
  key: 'ascend',
  name: 'Ascend',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please contact your Geoforce account manager to have API credentials issued for your organization. Enter the username and password you receive below.',
  loginComponent: (props: LoginComponentProps) => {
    return (
      <LoginCreds
        onValidityChange={props.onValidityChange}
        fields={[
          { label: 'Username', name: 'username', type: 'text', required: true },
          {
            label: 'Password',
            name: 'password',
            type: 'password',
            required: true,
          },
          {
            label: 'DOT Number (optional)',
            name: 'dot',
            type: 'text',
            required: false,
          },
        ]}
      />
    );
  },
};

export default ascendConfig;
